import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getAADUserAccessDetailReportCSV = (url) => {
    return apiRequestType(apiTypes.GET, apiConstants.REPORT.ACCESS_REPORT.GET_AAD_USER_ACCESS_DETAIL_REPORT_CSV(url))
}

export default getAADUserAccessDetailReportCSV